import { Check, ShieldCheck, Zap, Gift, Clock, BookOpen, FileText, Wrench, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
const deliverables = [{
  icon: BookOpen,
  title: "Ebook Completo",
  description: "7 módulos, 120+ páginas, formato PDF + móvil"
}, {
  icon: FileText,
  title: "12 Plantillas Editables",
  description: "Word + PDF, listas para usar"
}, {
  icon: Wrench,
  title: "Herramientas Prácticas",
  description: "Hojas cálculo, checklists, calendarios"
}, {
  icon: Mail,
  title: "Soporte por Email",
  description: "Respuestas dentro de 48 horas"
}];
const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";
const OfferSection = () => {
  const handleBuyClick = () => {
    window.open(HOTMART_CHECKOUT_URL, "_blank");
  };
  return <section className="relative overflow-hidden section-padding bg-[hsl(215,12%,40%)]">
      {/* Background dots pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)`,
        backgroundSize: '20px 20px'
      }} />
      </div>
      <div className="container-centered relative z-10">
        <div className="mx-auto max-w-4xl">
          
          {/* What You Receive Section */}
          <div className="mb-12 rounded-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-6 shadow-2xl sm:p-8 border border-white/10">
            <h2 className="mb-8 text-center font-display text-2xl font-bold sm:text-3xl">
              <span className="bg-gradient-to-r from-white via-cyan-200 to-white bg-clip-text text-transparent">
                Esto Es Lo Que Recibes
              </span>{" "}
              <span className="bg-gradient-to-r from-teal-400 via-cyan-400 to-amber-400 bg-clip-text text-transparent animate-pulse">
                Inmediatamente
              </span>
            </h2>
            
            <div className="grid gap-6 sm:grid-cols-2">
              {deliverables.map((item, index) => {
              const gradients = ["from-teal-500/20 via-cyan-500/10 to-transparent border-teal-500/30", "from-amber-500/20 via-orange-500/10 to-transparent border-amber-500/30", "from-purple-500/20 via-pink-500/10 to-transparent border-purple-500/30", "from-emerald-500/20 via-green-500/10 to-transparent border-emerald-500/30"];
              const iconColors = ["from-teal-400 to-cyan-400", "from-amber-400 to-orange-400", "from-purple-400 to-pink-400", "from-emerald-400 to-green-400"];
              return <div key={index} className={`group flex items-start gap-4 rounded-xl bg-gradient-to-br ${gradients[index]} p-5 border backdrop-blur-sm transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-cyan-500/20`}>
                    <div className={`flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br ${iconColors[index]} shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                      <item.icon className="h-7 w-7 text-slate-900" />
                    </div>
                    <div>
                      <h3 className="font-display font-bold text-white text-lg">{item.title}</h3>
                      <p className="text-sm text-gray-300 mt-1">{item.description}</p>
                    </div>
                  </div>;
            })}
            </div>

            {/* Immediate Access Note */}
            <div className="mt-8 rounded-xl bg-gradient-to-r from-teal-500/10 via-cyan-500/5 to-amber-500/10 border border-cyan-500/30 p-5 backdrop-blur-sm">
              <p className="text-base text-white font-semibold flex items-center gap-2 flex-wrap">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-gradient-to-r from-teal-400 to-cyan-400">
                  <Zap className="h-4 w-4 text-slate-900" />
                </span>
                <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">Acceso Inmediato:</span>
                <span className="text-gray-200">Después de tu compra, recibirás instantáneamente:</span>
              </p>
              <div className="mt-4 grid gap-2 sm:grid-cols-3">
                <div className="flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2">
                  <Check className="h-4 w-4 text-teal-400 flex-shrink-0" />
                  <span className="text-sm text-gray-200">Ebook + bonos</span>
                </div>
                <div className="flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2">
                  <Check className="h-4 w-4 text-cyan-400 flex-shrink-0" />
                  <span className="text-sm text-gray-200">Instrucciones</span>
                </div>
                <div className="flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2">
                  <Check className="h-4 w-4 text-amber-400 flex-shrink-0" />
                  <span className="text-sm text-gray-200">Primera tarea HOY</span>
                </div>
              </div>
            </div>
          </div>

          {/* Main Offer Card */}
          <div className="relative overflow-hidden rounded-3xl bg-card shadow-card">
            {/* Top Badge */}
            <div className="bg-gradient-to-r from-teal-600 via-cyan-500 to-amber-500 py-3 text-center">
              <p className="font-display text-sm font-bold text-slate-900 sm:text-base">
                🔥 OFERTA ESPECIAL DE LANZAMIENTO - ¡Precio Más Bajo del Año!
              </p>
            </div>

            {/* Hotmart Badge */}
            <div className="flex items-center justify-center gap-3 border-b border-border bg-muted/50 py-3">
              <div className="flex items-center gap-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#F04E23]">
                  <span className="text-xs font-bold text-white">H</span>
                </div>
                <span className="text-sm font-semibold text-card-foreground text-center">Vendido
a través de</span>
                <span className="text-base font-bold text-[#F04E23]">Hotmart</span>
              </div>
              <span className="rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary text-center">
                Plataforma Verificada
              </span>
            </div>

            {/* Main Content */}
            <div className="p-6 sm:p-10">
              {/* Price Section */}
              <div className="rounded-2xl bg-muted p-6 text-center">
                <div className="flex items-center justify-center gap-4 flex-wrap">
                  <p className="text-3xl font-bold text-muted-foreground line-through">
                    $488
                  </p>
                  <p className="font-display font-extrabold text-primary sm:text-6xl text-6xl">
                    $16<span className="text-3xl">.99</span>
                  </p>
                  <span className="rounded-full bg-accent px-3 py-1 text-sm font-bold text-accent-foreground">
                    AHORRA 96%
                  </span>
                </div>
              </div>

              {/* CTA Button */}
              <div className="mt-8 btn-container">
                <Button onClick={handleBuyClick} size="lg" className="btn-cta relative h-16 bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-6 pl-14 text-lg font-bold text-slate-900 shadow-[0_0_30px_rgba(20,184,166,0.4)] transition-all hover:scale-105 hover:opacity-90 animate-pulse-glow sm:px-12 sm:pl-16 sm:text-xl">
                  <Zap className="absolute left-6 h-6 w-6" />
                  <span className="block w-full text-center whitespace-normal leading-tight">
                    COMPRAR AHORA - $16.99
                  </span>
                </Button>
                <p className="mt-4 text-center text-sm text-muted-foreground">
                  🔒 Pago seguro • ⚡ Acceso inmediato • ✅ Garantía 60 días
                </p>
              </div>

              {/* Trust Elements */}
              <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-sm text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Clock className="h-4 w-4 text-primary" />
                  Acceso inmediato
                </span>
                <span className="flex items-center gap-1">
                  <Gift className="h-4 w-4 text-accent" />
                  Bonos incluidos
                </span>
                <span className="flex items-center gap-1">
                  <ShieldCheck className="h-4 w-4 text-primary" />
                  Garantía 60 días
                </span>
              </div>
            </div>

            {/* Guarantee Section */}
            <div className="border-t border-border bg-primary/5 p-6 sm:p-8">
              <div className="mx-auto flex max-w-lg flex-col items-center gap-4 text-center sm:flex-row sm:text-left">
                <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-primary/20">
                  <ShieldCheck className="h-8 w-8 text-primary" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-foreground">
                    ¿Y si no funciona para ti?
                  </h3>
                  <p className="mt-1 text-sm text-muted-foreground text-left">
                     
Tienes 60 días completos para explorar el sistema sin riesgo.

Si sientes que el contenido no es lo que esperabas,
solicitas tu reembolso y listo.
Sin preguntas. Sin explicaciones.

El riesgo es 100% nuestro, no tuyo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default OfferSection;